// Build Trigger: 2026-04-08 11:20
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Navbar    from './components/layout/Navbar';
import Home      from './pages/Home';
import Animales  from './pages/Animales';
import Calendario from './pages/Calendario';
import Ranking   from './pages/Ranking';
import Donaciones from './pages/Donaciones';
import Reporte   from './pages/Reporte';
import Panel     from './pages/Panel';
import MessengerFloating from './components/ui/MessengerFloating';
import SponsorAd from './components/ui/SponsorAd';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Gracias           from './pages/Gracias';
import PublicContent     from './pages/PublicContent';
import { useAuth } from './context/AuthContext';
import './index.css';

function GlobalMessenger() {
  const { usuario } = useAuth();
  if (!usuario) return null;
  return <MessengerFloating usuario={usuario} />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/"           element={<Home />} />
            <Route path="/animales"   element={<Animales />} />
            <Route path="/calendario" element={<Calendario />} />
            <Route path="/ranking"    element={<Ranking />} />
            <Route path="/donaciones" element={<Donaciones />} />
            <Route path="/reporte"    element={<Reporte />} />
            <Route path="/panel"      element={<Panel />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/gracias"    element={<Gracias />} />
            <Route path="/mascota/:publicId"    element={<PublicContent tipo="mascota" />} />
            <Route path="/actividad/:publicId"  element={<PublicContent tipo="actividad" />} />
            <Route path="/campana/:publicId"    element={<PublicContent tipo="campana" />} />
            <Route path="/urgente/:publicId"    element={<PublicContent tipo="urgente" />} />
          </Routes>
        </main>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "'Nunito', sans-serif",
              fontWeight: 700,
              fontSize: 13,
              borderRadius: 10,
            },
            success: { style: { background: '#0e5c30', color: '#fff' } },
            error:   { style: { background: '#c0392b', color: '#fff' } },
          }}
        />
        <GlobalMessenger />
        <SponsorAd />
      </BrowserRouter>
    </AuthProvider>
  );
}
